import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { SamwinUserShortInfoRemoteDto } from '../../../../generated/swagger';
import { CallProgressState } from '../../../samwebDescription/samweb/callHistory/callProgressState';
import { CallHistoryChangeProgressState } from '../../../store/dashboard/brick-wall/brick-behaviour-state/brickTypes/call-history-browser-behaviour/call-history-browser-behaviour.actions';
import { CallHistoryBrowserBehaviourState } from '../../../store/dashboard/brick-wall/brick-behaviour-state/brickTypes/call-history-browser-behaviour/call-history-browser-behaviour.state';

@Component({
   selector: 'samweb-call-progress-info',
   templateUrl: './call-progress-info.component.html',
   styleUrls: ['./call-progress-info.component.scss'],
})
export class CallProgressInfoComponent implements OnInit {
   constructor(private store: Store) {}

   @Input()
   public callHistoryForCallId: string;

   @Input()
   public originalAgentId?: number;

   public callProgressPossibleStates = CallProgressState.values();

   public progressState$: Observable<CallProgressState>;
   public progressUserInfo$: Observable<SamwinUserShortInfoRemoteDto>;

   ngOnInit(): void {
      this.progressState$ = this.store.select(CallHistoryBrowserBehaviourState.getProgressStateForHistoryEntryFn).pipe(
         map((fn) => fn(this.callHistoryForCallId)),
         distinctUntilChanged()
      );

      this.progressUserInfo$ = this.store.select(CallHistoryBrowserBehaviourState.getProgressByUserForHistoryEntryFn).pipe(
         map((fn) => fn(this.callHistoryForCallId)),
         distinctUntilChanged((prev, curr) => prev?.id === curr?.id)
      );
   }

   public changeProgressType(progressState: CallProgressState): void {
      this.store.dispatch(new CallHistoryChangeProgressState(this.callHistoryForCallId, progressState, this.originalAgentId));
   }
}
